export function isMtBank() {
  return false;
}
